module.exports = __webpack_public_path__ + "img/LR-anwendungsgebiete_IMMUNSYSTEM_kacheln_honey.4bcc4721.png";